import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
import type { LeaderboardPageResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The leaderboard (GET /ranking/leaderboard) in SERVER ORDER. A selected
 * facility scopes the board; omitting it returns the GLOBAL board — so
 * `facility_id` is only passed when a facility is present (never `facility_id:
 * undefined`, which would still serialize a param). The hook returns rows
 * verbatim — pages/components must NOT re-sort.
 *
 * `enabled` lets a caller defer the fetch (the home page only loads the board
 * once its in-page Leaderboard tab is opened — no eager request).
 */
export function useLeaderboard(
  facilityId: string | undefined,
  limit: number,
  offset: number,
  enabled = true,
) {
  return useQuery<LeaderboardPageResponse>({
    queryKey: queryKeys.compete.leaderboard(facilityId, limit, offset),
    queryFn: () =>
      rankingApi.getLeaderboard({
        ...(facilityId ? { facility_id: facilityId } : {}),
        limit,
        offset,
      }),
    enabled,
  });
}
